import { DrawerPresentationProps } from "@insite/mobius/Drawer";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

export interface StoreDrawerProps {
    drawer?: DrawerPresentationProps;
    drawerTitle?: TypographyPresentationProps;
}

export const drawerProps: StoreDrawerProps = {
    drawer: {
        size: 500,
        cssOverrides: {
            drawerTitle: css`
                padding: 1em 1.5em;
                background-color: ${getColor("common.background")};
            `,
            titleButton: css`
                padding: 0 0.375em;
                background-color: ${getColor("common.background")};
                border-color: ${getColor("common.background")};
            `,
            drawerContainer: css`
               ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [{ values: ["none", null], properties: ["display"] }],
                        mediaOptions.max,
                    )
                }
            `,
        },
        closeButtonProps: {
            shape: "pill",
            color: "text.main",
        }
    },
    drawerTitle: {
        weight: TYPOGRAPHY.weight.bold,
        color: "text.main",
    },
};
